var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollContainer",staticClass:"messages-scroll"},[_c('div',{staticClass:"msg-blocks"},_vm._l((_vm.getMessageBlocks),function(mb){return _c('MessageBlock',{key:((mb.userId) + "-" + (mb.createdAt)),attrs:{"msgBlock":mb}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }